/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LegalTechnicalSkillProficiency {
  SomeFamiliarity = "SomeFamiliarity",
  HighProficiency = "HighProficiency",
}

export const LegalTechnicalSkillProficiencyDisplay: Record<LegalTechnicalSkillProficiency, string> = {
  [LegalTechnicalSkillProficiency.SomeFamiliarity]: "Some Familiarity",
  [LegalTechnicalSkillProficiency.HighProficiency]: "High Proficiency",
};
